import isNil from 'lodash/isNil';
import { devWarning } from '@tanium/coreui-utils';
import { getSelectedCount } from '@tanium/react-use-selection';
import { PrimaryColumn, RibbonColumn } from '../types/StackedRibbonListComponentTypes';

export const validateColumns = <TItem>(columns: RibbonColumn<TItem>[] = []) => {
  const markedPrimary = columns.filter((c) => (c as PrimaryColumn<TItem>).primary);
  const markedPrimaryKeys = markedPrimary.reduce(
    (acc, { dataKey }) => `${acc}${acc && ', '}${dataKey}`,
    '',
  );
  devWarning(
    () => markedPrimary.length <= 1,
    `Only one field can be marked as primary. Found ${markedPrimary.length} with the following dataKeys: ${markedPrimaryKeys}`,
  );
  devWarning(
    () =>
      !columns.some(
        (c) =>
          !(c as PrimaryColumn<TItem>).primary &&
          (!!(c as PrimaryColumn<TItem>).subtitleKey ||
            !!(c as PrimaryColumn<TItem>).subtitleRenderer),
      ),
    'subtitleKey, subtitleRenderer are reserved for the primary field.',
  );
};

interface ResultsCountsProps {
  itemCount: number;
  totalItemCount?: number;
  selection?: Set<number | string>;
  selectionMode?: 'include' | 'exclude';
}

/**
 * Validates the results count props and return the correct display for the StackedRibbonList header.
 */
export const validateResultsCountsProps = ({
  itemCount = 0,
  totalItemCount,
  selection = new Set(),
  selectionMode = 'include',
}: ResultsCountsProps) => {
  const totalCount = isNil(totalItemCount) ? itemCount : totalItemCount;
  const currentCount = isNil(totalItemCount) ? undefined : itemCount;

  const selectedCount = getSelectedCount(selection, selectionMode, itemCount);
  return {
    selectedCount,
    total: totalCount,
    count: currentCount,
  };
};
